import React, { useEffect } from "react";
import {
  compareAsc,
  compareDesc,
  differenceInDays,
  parse,
  parseISO,
} from "date-fns";
import { Divida } from "../../../../../../../types/divida-interface";
import { useNeg } from "../../../../../../../context/NegContext";
import { credoresGazin } from "../../../../../../../utils/credoresGazin";
import { useDividas } from "../../../../../../../context/DividasContext";

interface TabelaParcelasDataProps {
  prestacoes: Divida[];
  tipoNeg: string;
}

export const TabelaParcelasData = ({
  prestacoes,
  tipoNeg,
}: TabelaParcelasDataProps) => {
  const {
    addParcelasNeg,
    parcelasNeg,
    setSelection,
    addParcelasNegGroup,
    contratoNeg,
  } = useNeg();
  const { selectedCredor } = useDividas();

  useEffect(() => {
    if (tipoNeg === "AP" && prestacoes && prestacoes.length > 0) {
      setSelection("selectAll");
      addParcelasNegGroup(prestacoes);
      // prestacoes.map(p => addParcelasNeg(p))
      // console.log(prestacoes, parcelasNeg)
    }
  }, [tipoNeg]);

  function formatDate(date: string) {
    const [dia, mes, ano] = date.split("/");
    return `${mes}/${dia}/${ano}`;
  }

  const parcelas =
    prestacoes && prestacoes?.length > 0
      ? prestacoes.sort((a, b) => {
          const dataA = parse(a.datvenci, "dd/MM/yyyy", new Date());
          const dataB = parse(b.datvenci, "dd/MM/yyyy", new Date());
          return compareAsc(dataA, dataB);
        })
      : ([] as Divida[]);

  function converterParaNumeroAmericano(valorBrasileiro: string) {
    const semPontoMilhar = valorBrasileiro.replace(/\./g, "");
    const numeroAmericano = semPontoMilhar.replace(",", ".");
    return parseFloat(numeroAmericano);
  }

  function converterParaNumeroBrasileiro(valorAmericano: number) {
    const valorString = valorAmericano.toFixed(2).toString();
    const partes = valorString.split(".");
    const parteInteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parteInteira + "," + partes[1];
  }

  function totalParcela(valor: number, multa: number, juros: number) {
    const total = valor + multa + juros;
    return converterParaNumeroBrasileiro(total);
  }

  return (
    <div className="my-2">
      <div className="overflow-x-hidden">
        <div className="inline-block w-full align-middle">
          <div className="max-h-[150px] overflow-hidden overflow-y-auto rounded-sm  border-2">
            <table className=" w-full  border-collapse divide-y divide-gray-200">
              <thead className="sticky top-0 bg-gray-200">
                <tr>
                  <th scope="col" className="th-parcelas">
                    {/* Checkbox */}
                  </th>
                  <th scope="col" className="th-parcelas">
                    Contrato
                  </th>
                  <th scope="col" className="th-parcelas">
                    Parcelas
                  </th>
                  <th scope="col" className="th-parcelas">
                    Vencimento
                  </th>
                  <th scope="col" className="th-parcelas">
                    Atraso
                  </th>
                  <th scope="col" className="th-parcelas">
                    Valor Parc.
                  </th>
                  <th scope="col" className="th-parcelas">
                    Juros
                  </th>
                  <th scope="col" className="th-parcelas">
                    Multa
                  </th>
                  <th scope="col" className="th-parcelas">
                    Valor Desc.
                  </th>
                  <th scope="col" className="th-parcelas">
                    Total atual
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {prestacoes &&
                  prestacoes?.length > 0 &&
                  parcelas.map((p, i) => (
                    <tr key={p.id}>
                      <td className="td-parcelas">
                        <input
                          type="checkbox"
                          className="h-3 w-3 rounded-sm accent-rose-600"
                          onChange={() => {
                            tipoNeg !== "AP" &&
                              contratoNeg.permitedivida &&
                              addParcelasNeg(p);
                          }}
                          defaultChecked={tipoNeg === "AP"}
                          checked={
                            parcelasNeg.find((item) => item.id === p.id)
                              ? true
                              : false
                          }
                        />
                      </td>
                      <td className="td-parcelas">
                        <span>{p.contrato}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p?.numeroparcela}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.datvenci}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>
                          {differenceInDays(
                            new Date(),
                            new Date(formatDate(p.datvenci))
                          )}
                        </span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.valorpago}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>
                          {tipoNeg === "AP" &&
                          credoresGazin.find(
                            (item) => item === selectedCredor?.credor_crm
                          )
                            ? "0,00"
                            : p.juros}
                        </span>
                      </td>
                      <td className="td-parcelas">
                        <span>
                          {tipoNeg === "AP" &&
                          credoresGazin.find(
                            (item) => item === selectedCredor?.credor_crm
                          )
                            ? "0,00"
                            : p.multa}
                        </span>
                      </td>
                      <td className="td-parcelas">
                        {/* <span>{p.desconto}</span> */}
                        <span>0,00</span>
                      </td>
                      <td className="td-parcelas">
                        {/* // */}
                        {/* <span>{totalParcela(converterParaNumeroAmericano(p.valorpago), converterParaNumeroAmericano(p.multa),
                          converterParaNumeroAmericano(p.juros))}</span> */}
                        <span>{p.valorprincipal}</span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
